import React, {Component} from "react";
import {Provider} from "react-redux";
import store from "./store";
import "./App.css";
import Switcher from "./components/switcher";
import MarketoForm from "./components/marketo-form";
import {storyboard} from "./data";
import {retrieveRecommendations} from "./actions";


class App extends Component {
  componentDidMount() {
    store.dispatch(retrieveRecommendations())
  }

  render() {
    return (
      <div className="App container">
        <Provider store={store}>
          <div>
            <MarketoForm />
            <Switcher storyboard={storyboard}/>
          </div>
        </Provider>
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js